require('./rokuConnectService');

"use strict";

angular.module('app.rokuConnect.rokuConnectController', [
    'app.rokuConnect.rokuConnectService',
])
    .controller('app.rokuConnect.rokuConnectController', [
        '$scope', 'app.rokuConnect.rokuConnectService',
        function ($scope, rokuConnect) {
            $scope.error = null;
            $scope.message = null;
            $scope.rokuPin = null;

            $scope.link = function () {
                $scope.error = null;
                $scope.message = null;

                rokuConnect.validatePin($scope.rokuPin)
                    .then(function (response) {
                        if (response.data.error) {
                            $scope.error = response.data.error;
                        }

                        if(response.status === 204){
                            $scope.rokuPin = null;
                            $scope.message = 'Roku connected successfully';
                        }
                    });
            }
        }
    ]);



// WEBPACK FOOTER //
// ./app.v2/components/rokuConnect/rokuConnectController.js